// src/lib/pluginManager.js

export async function pluginManager(
  apply,
  pluginId,
  URL,
  serverUrl,
  guiname,
  accountId,
  insertIntoToastList,
) {
  // Creating JSON object for the request payload

  const payload = {
    guiname,
    plugin_id: pluginId,
    plugin_state: apply,
    server_url: serverUrl,
    account_id: accountId
  };
  // Sending the POST request
  try {
    const response = await fetch(`${URL}/api/plugins/turn`, {
      method: "POST",
      // Bez ovoga ruta vraća 401: od 01.09. GUI ime uzima iz potpisanog
      // sesijskog kolačića, a ne iz tela zahteva.
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      if (apply) {
        insertIntoToastList("Plugin applied successfully", "success", false);
      } else {
        insertIntoToastList("Plugin disabled successfully", "success", false);
      }
      return { status: apply, plugin: pluginId, guiname };
    } else {
      if (apply) {
        insertIntoToastList("Plugin has not been enabled", "error", false);
      } else {
        insertIntoToastList("Plugin has not been disabled", "error", false);
      }
      // console.log("An error occurred while changing the plugin.");
    }
  } catch (error) {
    //  console.log("An error occurred while sending the request:", error);
  }
}

export async function pluginInstaller(
  pluginId,
  URL,
  guiname,
  accountId,
  serverUrl,
  insertIntoToastList,
) {
  // Creating JSON object for the request payload
  const payload = {
    guiname,
    plugin_id: pluginId,
    server_url: serverUrl,
    account_id: accountId,
  };

  try {
    // Sending the POST request
    const response = await fetch(`${URL}/api/plugins/buy`, {
      method: "POST",
      // Bez ovoga ruta vraća 401: od 01.09. GUI ime uzima iz potpisanog
      // sesijskog kolačića, a ne iz tela zahteva.
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      insertIntoToastList("Plugin installed successfully", "success", false);
      // console.log("Plugin successfully installed.");
    } else {
      insertIntoToastList("Plugin installation failed", "error", false);
      // console.warn("An error occurred while changing the plugin.");
    }
  } catch (error) {
    //  console.log("An error occurred while sending the request:", error);
  }
}